export default __webpack_public_path__ + "static/media/paidFee.b78f5120.svg";